import React, {FC} from 'react';

import {Icon, PayPalCredit} from '@optimaxdev/icons';

import {PlacingOrderScreen} from 'desktop/components/placingOrderScreen/placingOrderScreen';

import s from './paypalButtonFooter.scss';

export type PropsType = {
    error: string;
    loading: boolean;
};

/**
 * Footer for PayPal button
 * @constructor
 */
export const PaypalButtonFooter: FC<PropsType> = ({error, loading}) => {
    return (
        <>
            <div className={s.availableText}>
                Available with <Icon className={s.payPalCredit} icon={PayPalCredit} /> | Pay in 4
            </div>
            {error && <div className={s.errorMessage}>{error}</div>}
            {loading && <PlacingOrderScreen />}
        </>
    );
};
